import { render } from "./productPageBrand.vue?vue&type=template&id=7eeba660"
import script from "./productPageBrand.vue?vue&type=script&lang=js"
export * from "./productPageBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__